import { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

interface iDirection {
    isRTL: boolean;
    toggleLayoutDirection: (boolean: boolean) => void;
}

const LayoutDirectionContext = createContext<iDirection>({
    isRTL: false,
    toggleLayoutDirection: () => {},
});

export const useLayoutDirection = () => {
    return useContext(LayoutDirectionContext);
};

export const LayoutDirectionProvider = ({ children }) => {
    const {i18n} = useTranslation();
    const isLandExistInUrl = (): { isEn: boolean, isHe: boolean } => {
        const isLang = window.location.search.indexOf('lang=')
        if (isLang < 0) return null;

        const isEn = window.location.search.indexOf('lang=en')        
        return {
            isEn: isEn > 0,
            isHe: isEn < 0
        };
    }

    const [isRTL, setIsRTL] = useState<boolean>(() => {        
        const hasLang = isLandExistInUrl()                
        const _isRTL = localStorage.getItem('isRTL') === 'true'

        if (!hasLang) {            
            if (_isRTL == null) {
                localStorage.setItem("isRTL", i18n.language === 'he' ? 'true' : 'false');
                return i18n.language === 'he'
            };
            i18n.changeLanguage(_isRTL && 'he' || 'en');

            return _isRTL;
        }
        
        localStorage.setItem("isRTL", hasLang.isHe ? 'true' : 'false');         
        i18n.changeLanguage(_isRTL && 'he' || 'en');
        
        return hasLang.isHe;
    });

    const toggleLayoutDirection = (boolean) => setIsRTL(boolean);

    useEffect(() => {
        localStorage.setItem("isRTL", isRTL.toString());

        const rootHtml = document.getElementById("root-html");
        rootHtml && rootHtml.setAttribute("dir", isRTL ? "rtl" : "ltr");

        document.documentElement.setAttribute("lang", isRTL ? "he" : "en");
        i18n.changeLanguage(isRTL ? 'he' : 'en');
    }, [isRTL]);

    useEffect(() => {
        isLandExistInUrl()        
    }, []);


    return (
        <LayoutDirectionContext.Provider value={{ isRTL, toggleLayoutDirection }}>
            {children}
        </LayoutDirectionContext.Provider>
    );
};